<template>
    <section class="mt-3">
        <div class="container-lg">
            <div class="row">
            <div>
                <router-link :to="{ name: 'Home'}" class="btn btn-outline-primary border-0 mb-3"><i class="bi bi-arrow-left"></i> {{ translated.home }}</router-link>
                
            </div>
            
        </div>
        <div class="row g-4">
    
            <div class="row"><h1 class="display-4">{{ translated.title }}</h1></div>

            <!-- Progress Tracker -->
            <div class="mb-4">
              <ProgressTracker
                v-if="trainings.steps && trainings.steps.length > 0"
                :steps="trainings.steps"
                :activeOperation="trainings.activeOperation"
                :provisioningState="trainings.provisioningState"
              />
              <!-- Retry button when provisioning has failed -->
              <div class="d-flex justify-content-end mt-2" v-if="trainings.provisioningState === 'failed'">
                  <button class="btn btn-warning" @click="retryProvisioning" :disabled="retrying">
                      <span v-if="retrying"><span class="spinner-border spinner-border-sm"></span> Retrying...</span>
                      <span v-else><i class="bi bi-arrow-clockwise"></i> Retry Provisioning</span>
                  </button>
              </div>
            </div>
    
            <div class="row mb-4" v-if="trainings.actions && trainings.actions.claimAccount">
                <div class="col-12">
                    <div class="card border-primary">
                        <div class="card-header bg-primary text-white">
                            <i class="bi bi-qr-code"></i> Claim Account Session Active
                        </div>
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-md-8">
                                    <h5 class="card-title">Share this link with delegates:</h5>
                                    <div class="input-group">
                                        <input type="text" class="form-control" :value="'demogfe.com/GfE-' + trainings.sessionName" readonly>
                                        <button class="btn btn-outline-secondary" type="button" @click="copyToClipboard('demogfe.com/GfE-' + trainings.sessionName)">
                                            <i :class="iconState === 'clipboard' ? 'bi bi-clipboard' : 'bi bi-check'"></i> Copy
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-4 text-end">
                                    <router-link :to="{ name: 'Presenter', params: { sessionName: trainings.sessionName }}" target="_blank" class="btn btn-success btn-lg">
                                        <i class="bi bi-projector"></i> Launch Presenter View
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
            <div class="card shadow-sm h-100">
              <div class="card-body">
                <h5 class="section-header"><i class="bi bi-card-text"></i> {{ translated.overview}}</h5>
                <table class="table table-striped mb-0">
                    <tbody>
                        <tr>
                        <td>{{ translated.sessionName}}:</td>
                        <td>{{trainings.sessionName}}</td>
                    </tr>
                    <tr>
                        <td>{{ translated.demoName}}:</td>
                        <td>{{ trainings.demoName}}</td>
                    </tr>
                    <tr>
                        <td>{{ translated.startDate}}:</td>
                        <td>{{ moment.tz(trainings.startDate.toDate(), trainings.timezone) }}</td>
                    </tr>
                    <tr>
                        <td>{{ translated.endDate}}:</td>
                        <td>{{ moment.tz(trainings.endDate.toDate(), trainings.timezone)}}</td>
                    </tr>
                    <tr v-if="trainings.actions.duetAI && trainings.duetAIstartDate">
                        <td>Gemini start</td>
                        <td>{{ moment.tz(trainings.duetAIstartDate.toDate(), trainings.timezone) }}</td>
                    </tr>
                    <tr v-if="trainings.actions.duetAI && trainings.duetAIendDate">
                        <td>Gemini end</td>
                        <td>{{ moment.tz(trainings.duetAIendDate.toDate(), trainings.timezone) }} <small v-if="timeDifferenceInMinutes(trainings.duetAIendDate) <= 0" class="text-muted">Expired</small></td>
                    </tr>
                    <tr>
                        <td>{{ translated.language}}:</td>
                        <td>{{ languages.filter((lang)=> lang.code === trainings.language)[0].localeInLanguage }}</td>
                    </tr>
                    <tr>
                        <td>{{ translated.demoAssets}}:</td>
                        
                        
                        <td v-if="trainings.status.includes(`Content copied`)"><a :href="'https://drive.google.com/drive/folders/'+trainings.folder" target="_blank" style="padding-left: 0px;">{{trainings.sessionName}} Folder <i class="bi bi-box-arrow-up-right"></i></a></td>
                        <td v-else>{{translated.creatingDemo.resources}} <div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>
        </td>
                    </tr>
                    <tr v-for="classroom in classrooms" :key="classroom">
                            <td v-if="trainings.classroom ">Google Classroom:</td>
                        <td v-if="trainings.classroom "><a :href="classroom.alternateLink" target="_blank" style="padding-left: 0px;">{{ classroom.name}} <i class="bi bi-box-arrow-up-right"></i></a></td>
                    
                        
                        </tr>
                    <tr v-if="trainings.classroom  && !trainings.status.includes(`Classroom created`)">
                        <td>Google Classroom:</td>
                        <td>
                        {{translated.creatingDemo.classroom}} <div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>
                    </td>
                    </tr>    
                    </tbody>
                    
                </table>
              </div>
            </div>
            </div>
            <div class="col-md-6">
            <div class="card shadow-sm h-100" v-if="trainings.users">
              <div class="card-body">
                <h5 class="section-header"><i class="bi bi-people"></i> {{translated.userDetails}}</h5>
            
            <table class="table table-striped">
                <tbody>
                    <tr>
                    <td>{{translated.usernames}}:</td>
                    <td>
                        <div v-if="trainings.actions && trainings.actions.claimAccount">
                            <span class="text-success fw-bold"><i class="bi bi-check-circle-fill"></i> Account claiming active</span>
                            <small class="d-block text-muted mt-1">Accounts will be created on-demand as delegates claim them.</small>
                        </div>
                        <div v-else-if="trainings.status.includes(`Users created`)">
                            {{ trainings.userName }}1@<span v-if="trainings.demoName == 'Google Workspace Security Demo'">admin.</span>{{ domain }} to {{trainings.userName+trainings.userNumber}}@<span v-if="trainings.demoName == 'Google Workspace Security Demo'">admin.</span>{{ domain }} <i class="bi bi-check-circle-fill"></i>
                        </div>
                        <div v-else>
                            {{translated.creatingDemo.users}} {{trainings.userName}}1 to {{trainings.userName+trainings.userNumber}} <div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>{{translated.password}}:</td>
                    <td>gogoogle1</td>
                </tr>
                <tr>
                    <td>{{translated.numberOfUsers}}:</td>
                    <td>
                        <span v-if="trainings.actions && trainings.actions.claimAccount">
                            <strong class="text-primary">{{ students.length }}</strong> / {{ trainings.userNumber }} claimed
                        </span>
                        <span v-else>
                            {{ trainings.userNumber }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>{{translated.license}}:</td>
                    <td>{{ licenses.filter((lic)=> lic.skuId === trainings.userLicense)[0].name}}</td>
                </tr>
                <tr>
                    <td>Group: </td>
                    <td>{{ trainings.userName }}-group@demogfe.com</td>
                </tr>
                <tr>
                    <td>Gemini teen experience:</td>
                    <td><div class="form-check form-switch ms-2" >
                <input class="form-check-input" type="checkbox" id="gemini" v-model="trainings.geminiTeenExperience" @change="updateGeminiTeen()">
                <label class="form-check-label ms-2" for="users"></label>
                <span class="tt ms-2" data-bs-placement="bottom" data-bs-toggle="tooltip" title="Enable Gemini teen experience for Gemini app.">
                      <i class="bi bi-info-circle-fill text-muted"></i>
                  </span>
                </div></td>
                </tr>
                <tr v-if="trainings.demoName == 'Google Workspace Security Demo'">
                    <td>2SV Backup Codes:</td>
                    <td>
                        <span class="badge bg-warning text-dark">
                            <i class="bi bi-shield-lock"></i> Codes generated
                        </span>
                        <small class="d-block text-muted mt-1">
                            Codes are stored on the individual student records below. 
                            Delegates will also see them when they claim their account.
                        </small>
                    </td>
                </tr>
                </tbody>
                
            </table>
              </div>
            </div>
            </div>
            
            <div class="row mt-4" v-if="students && students.length > 0">
                <h5 class="section-header"><i class="bi bi-people-fill"></i> Session Users</h5>
                <div class="table-responsive">
                    <table class="table table-striped table-hover border">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">Username</th>
                                <th scope="col">Password</th>
                                <th scope="col">Status</th>
                                <th scope="col">Claimed At</th>
                                <th scope="col">Backup Codes (2SV)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="student in students" :key="student.id">
                                <td>{{ student.email }}</td>
                                <td>gogoogle1</td>
                                <td>
                                    <span v-if="student.isClaimed" class="badge bg-success">
                                        <i class="bi bi-person-check-fill me-1"></i> Claimed
                                    </span>
                                    <span v-else class="badge bg-secondary">Created</span>
                                </td>
                                <td>
                                    <span v-if="student.claimedAt" class="text-muted small">
                                        {{ moment(student.claimedAt.toDate()).format('LLL') }}
                                    </span>
                                    <span v-else class="text-muted small">-</span>
                                </td>
                                <td>
                                    <div v-if="student.backupCodes && student.backupCodes.length > 0">
                                        <span v-for="(code, index) in student.backupCodes.slice(0, 3)" :key="index" class="badge bg-light text-dark border me-1 font-monospace">{{ code }}</span>
                                        <span v-if="student.backupCodes.length > 3" class="badge bg-secondary" title="More codes available">...</span>
                                    </div>
                                    <span v-else class="text-muted small"><em>None</em></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-4">
            <h5 class="section-header"><i class="bi bi-folder"></i> {{ translated.resources }}</h5>
    
            <div class="accordion" id="accordionPanelsStayOpenExample">
                <div class="accordion-item" v-if="trainings.demoName == 'Google Workspace Security Demo'">
                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                    <img src="../../assets/icons/admin.png" width="28" class="me-2"/>Google Admin Console
                </button>
                </h2>
                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingThree">
                <div class="accordion-body">
                    <h3>Google Workspace Security Demo Login Instructions</h3>
    <hr>
    
    <div>
        <h5>{{ translated.accountDetails }}</h5>
        <div class="col-lg-8">
        <div class="input-group mb-4">
        <span class="input-group-text">
            <strong>Username</strong>
        </span>
        <input type="text" class="form-control" v-model="adminUser" @focus="() => copyToClipboard(adminUser)" readonly>
        <span class="input-group-text" @click="() => copyToClipboard(adminUser)">
            
            <i :class="iconState === 'clipboard' ? 'bi bi-clipboard' : 'bi bi-clipboard-check'" ></i>
            
        </span>
    </div>
    <div class="input-group mb-4">
        <span class="input-group-text">
            <strong>Password</strong>
        </span>
        <input type="text" class="form-control" v-model="trainings.adminPassword" @focus="() => copyToClipboard2(trainings.adminPassword)" readonly>
        <span class="input-group-text" @click="() => copyToClipboard2(trainings.adminPassword)">
            
            <i :class="iconState2 === 'clipboard' ? 'bi bi-clipboard' : 'bi bi-clipboard-check'"></i>
            
        </span>
    </div>
        </div>
    
    </div>
    
    <h5>Logging In:</h5>
    <ol>
        <li>Navigate to the <a href="https://admin.google.com" target="_blank">Google Workspace Admin Console</a>.</li>
        <li>Use the above username and password to sign in.</li>
    </ol>
    
    <hr>
    
    <p><strong>Special Note:</strong></p>
    <p>Your demo account has been assigned an <strong>Admin Role</strong>. This role grants you access to demonstrate advanced security features within Google Workspace, such as the Security Dashboard and Investigation Tool.</p>
    <p>Remember, this is a temporary account for demo purposes only. Avoid storing personal or sensitive information.</p>
    
                    
                    </div>
                </div>
            </div>
            <div class="accordion-item" v-if="trainings.demoName == 'Gemini for Workspace'">
                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                    <img src="../../assets/icons/drive.png" width="28" class="me-2"/>Gemini for Workspace
                </button>
                </h2>
                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingThree">
                <div class="accordion-body">
    <div>
        <h3>Gemini for Workspace activity overview</h3>
        <p>
            We’ll demonstrate the predictability of Large Language Models by setting a scenario similar to Family Feud. We’ll ask the audience to provide some suggestions to a prompt. The prompt should include some elements which can lead to easy predictability. Suggesting randomization in the prompt makes it harder to predict an outcome. We’ll run the prompt and identify which of the audience suggestions match the output of the model. If we have no match we can groupthink around why the model may have given the information it did.         
        </p>
        <p>
            The ultimate intention here is to emphasize model predictability. It takes a human to provide true creativity. These models are helpful for kick starting creativity but should be evaluated by those using them.
        </p>
        <div>
            <a :href="'https://drive.google.com/drive/folders/'+trainings.folder" class="btn btn-outline-primary mb-4" target="_blank" >Open Gemini for Workspace resources folder <i class="bi bi-box-arrow-up-right"></i></a>
        </div>
        <button class="btn btn-success btn-lg mt-4" v-if="timeDifferenceInMinutes(userInfo.document.duetAITime) >= 0">Gemini for Workspace available for <CountdownTimer :startingMinutes="timeDifferenceInMinutes(userInfo.document.duetAITime)" /></button>
    
    
        
    </div>
    
    
    
                    
                    </div>
                </div>
            </div>
                <div class="accordion-item" v-if="trainings.status.includes(`Content copied`)">
                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                    <img src="../../assets/icons/drive.png" width="28" class="me-2"/> {{translated.trainingMaterials}}
                </button>
                </h2>
                <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingTwo">
                <div class="accordion-body">
                    <p>{{translated.folderP1}} <strong><a :href="'https://drive.google.com/drive/folders/'+trainings.folder" target="_blank">{{trainings.sessionName}} Folder <i class="bi bi-box-arrow-up-right"></i></a></strong> {{translated.folderP2}}</p>
             <a :href="'https://drive.google.com/drive/folders/'+trainings.folder" class="btn btn-outline-primary mb-4" target="_blank" >{{ translated.goTo}} {{ trainings.sessionName}} <i class="bi bi-box-arrow-up-right"></i></a>
    </div>
                </div>
            </div>
            <div class="accordion-item" v-if="trainings.classroom">
                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                    <img src="../../assets/icons/classroom.png" width="28" class="me-2"/> Google Classroom
                </button>
                </h2>
                <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse " aria-labelledby="panelsStayOpen-headingOne">
                <div class="accordion-body">
                    <p>{{ translated.classroomDescription}} 
            <span v-if="trainings.users">{{translated.classroomUsers}}</span>
            
            </p>
            <p>
                <span v-if="trainings.actions.originality">{{ translated.classroomOriginality}} <span v-if="trainings.demoName == 'Google Workspace & Chromebooks'"><i>Mission to Mars</i></span><span v-if="trainings.demoName == 'Classroom add-ons demo'"><i>Energy-Saving Tips</i></span> {{ translated.classroomOriginality2}}<i>Check plagiarism (originality)</i>.</span>
            </p>
            <div v-for="classroom in classrooms" :key="classroom">
                        <a :href="classroom.alternateLink" class="btn btn-outline-primary mb-4" target="_blank" >{{ translated.goTo}} {{ classroom.name}} <i class="bi bi-box-arrow-up-right" v-if="classroom.name != 'Space'"></i><span v-if="classroom.name =='Space'">🚀</span></a>
    
            </div>
            </div>
                </div>
            </div>
    
            <div class="accordion-item" v-if="trainings.actions.classVisit">
                <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseFour">
                    <img src="../../assets/icons/classroom.png" width="28" class="me-2"/> Class visits
                </button>
                </h2>
                <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse " aria-labelledby="panelsStayOpen-headingFour">
                <div class="accordion-body">
                    <p>You have been assigned an admin role that allows you to temporarily access classes, without being assigned as a permanent co-teacher.</p>
                    <p>To demo how to visit a class:</p>
                    <ol>
                        <li>Go to <a href="https://classroom.google.com/a/demogfe.com">Google Classroom</a></li>
                        <li>On the homepage or sidebar, click <strong>Visit a class</strong>.</li>
                        <li>To find a class to visit, search for one of the following users:
                            <ul>
                                <li>Teacher: Jackson Goldstein - jgoldstein@classroomacademy.demogfe.com</li>
                                <li>Student: Carly Sedayu - carlys@classroomacademy.demogfe.com</li>
                            </ul>
                        </li>
                    </ol>
                    <p><a href="https://support.google.com/edu/classroom/answer/13651766" class="btn btn-outline-primary mb-4" target="_blank" >Learn more about class visits</a></p>
                </div>
                </div>
            </div>
    
            <div class="accordion-item" v-if="trainings.actions.duetAI">
                <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true" aria-controls="panelsStayOpen-collapseFive">
                    <img src="../../assets/icons/drive.png" width="28" class="me-2"/> Gemini for Workspace
                </button>
                </h2>
                <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse " aria-labelledby="panelsStayOpen-headingFive">
                <div class="accordion-body">
                    <p>You and your student users have been assigned a Gemini for Workspace license.</p>
                    
                    <p><a href="https://workspace.google.com/blog/product-announcements/duet-ai" class="btn btn-outline-primary mb-4" target="_blank" >Learn more about Gemini for Workspace</a></p>
                </div>
                </div>
            </div>
    
            <div class="accordion-item" v-if="trainings.users && trainings.demoName != 'Google Workspace Security Demo'">
                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                    <img src="../../assets/icons/admin.png" width="28" class="me-2"/>Google Admin Console
                </button>
                </h2>
                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                <div class="accordion-body">
                    {{ translated.adminP1}} <a href="https://admin.google.com" target="_blank">Google Admin Console</a> {{translated.adminP2}}
                    <ul>
                        <li>{{trainings.orgPath}}/{{trainings.userName}}</li>
                        
                    </ul>
                    
                    </div>
                </div>
            </div>
            </div>
           
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <div class="card shadow-sm">
                        <div class="card-body d-flex align-items-center justify-content-between">
                            <h5 class="mb-0"><i class="bi bi-gear me-2"></i>Session Actions</h5>
                            <div>
                                <button type="button" class="btn btn-outline-secondary me-2" data-bs-toggle="modal" data-bs-target="#resetDemo">
                                    <i class="bi bi-arrow-clockwise me-1"></i> Recreate Demo Session
                                </button>
                                <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#resetAccounts">
                                    <i class="bi bi-arrow-clockwise me-1"></i> Reset User Accounts
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    
        
        <div class="modal fade" id="resetDemo" tabindex="-1" aria-labelledby="resetDemoLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 ref="modalTitle" class="modal-title" id="resetDemoLabel">Reset demo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          
            
          <div class="modal-body">
              <div v-if="resetError" class="alert alert-danger" role="alert">{{ resetError }}</div>
              <p>Resetting a demo will delete and recreate the demo assets, Google Classroom, and users using your existing settings.</p>
              <p>Are you sure you wish to reset {{ trainings.sessionName}} demo?</p>
        
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-danger" :disabled="resetting" @click="resetDemo()">
              <span v-if="resetting" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Reset
            </button>
            
          </div>
          
        </div>
      </div>
    </div>
    
    
    <div class="modal fade" id="resetAccounts" tabindex="-1" aria-labelledby="resetAccountsLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 ref="modalTitle" class="modal-title" id="resetAccountsLabel">Reset demo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          
            
          <div class="modal-body">
              <div v-if="resetAccountsError" class="alert alert-danger" role="alert">{{ resetAccountsError }}</div>
              <p>Resetting Google Drive and Gmail will delete all items in the demo user accounts.</p>
              <p>Are you sure you wish to reset Drive and Gmail for {{ trainings.sessionName}} demo users?</p>
        
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-danger" :disabled="resettingAccounts" @click="resetAccounts()">
              <span v-if="resettingAccounts" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Reset
            </button>
            
          </div>
          
        </div>
      </div>
    </div>
    
    
        </div>
        
    </section>
      
    </template>
    
    <script>
    import { db } from '../../firebase/config'
    import axios from "axios";
    import getCollection from '@/composables/getCollection'
    import getSubCollection from '@/composables/getSubCollection'
    import translate from '@/composables/translate'
    //import { useRouter } from 'vue-router'
    import moment from 'moment'
    // import DemoContentTable from '@/components/DemoContentTable.vue'
    import getUser from '@/composables/getUser'
    import getDoc from '@/composables/getDoc'
    import { computed, ref } from '@vue/reactivity';
    import { watch, onUnmounted } from 'vue';
    import { useStore } from 'vuex'
    import CountdownTimer from '@/components/CountdownTimer.vue';
    import ProgressTracker from '@/components/ProgressTracker.vue';
    import { doc, setDoc, collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
    import { Modal } from 'bootstrap';
    // firebase imports
    //import { db } from '@/firebase/config'
    //import { writeBatch, doc, addDoc, deleteDoc, updateDoc, collection, serverTimestamp } from 'firebase/firestore'
    
    export default {
        props: ['id'],
        setup(props){
            const { user,userInfo } = getUser()
            const store = useStore()
            const lang = computed(() => store.state.lang)
            const { document: trainings } = getDoc('trainings',props.id)
            const { documents: classrooms } = getSubCollection('trainings',props.id,'classrooms','','')
            
    
            let domain = 'demogfe.com'
            if (trainings.demoName == 'Google Workspace Security Demo') {
                domain = 'admin.demogfe.com'
            }
            
            const adminUser = ref()
            const adminPassword = ref('gogoogle1')
            const demoId = ref()
            let demoClassrooms = ref([])
            const students = ref([])
            let unsubStudents = null
    
            watch(trainings, (newVal) => {
                if (!newVal) return
                console.log('updated trainings', newVal.userName);
                adminUser.value = `${newVal.userName}-admin@admin.demogfe.com`
                demoId.value = newVal.demoId
                const { documents: demoResources } = getSubCollection('demos',demoId.value,'content',['fileType','==','classroom'],'')
                demoClassrooms.value = demoResources
    
                // Fetch students — clean up previous listener before creating a new one
                if (newVal.sessionName) {
                    if (unsubStudents) {
                        unsubStudents()
                    }
                    const q = query(collection(db, 'students'), where('sessionName', '==', newVal.sessionName), orderBy('number'))
                    unsubStudents = onSnapshot(q, (snap) => {
                        students.value = snap.docs.map(doc => ({...doc.data(), id: doc.id}))
                    })
                }
            })
    
            onUnmounted(() => {
                if (unsubStudents) {
                    unsubStudents()
                }
            })
            
    
            
            const { getLanguage, translated } = translate()
            getLanguage('sessionDetails',lang)
    
            const languages = ref([])
            axios.get('/data/locale.json')
            .then((res) => {
            languages.value = res.data.languages
            })
    
                    const timeDifferenceInMinutes = (duetAITime) => {
                // Assuming duetAITime is a Firestore Timestamp
                // Convert it to a JavaScript Date object
                const duetAIDate = duetAITime.toDate();
    
                // Add 12 hours to the duetAITime
                duetAIDate.setHours(duetAIDate.getHours() + 12);
    
                // Get the current date and time
                const now = new Date();
    
                // Calculate the difference in milliseconds
                const diffInMs = duetAIDate - now;
    
                // Convert difference to minutes (Note: 1 minute = 60,000 milliseconds)
                const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    
                return diffInMinutes;
            };
    
            const licenses = [
            { productId: '101031', skuId: '1010310005', name: 'Google Workspace for Education Standard', total: 0 },
            { productId: '101031', skuId: '1010310006', name: 'Google Workspace for Education Standard (Staff)', total: 0 },
            { productId: '101031', skuId: '1010310007', name: 'Google Workspace for Education Standard (Extra Student)', total: 0 },
            { productId: '101031', skuId: '1010310008', name: 'Google Workspace for Education Plus', total: 10000, default: true },
            { productId: '101031', skuId: '1010310010', name: 'Google Workspace for Education Plus (Extra Student)', total: 0 },
            { productId: '101037', skuId: '1010370001', name: 'Google Workspace for Education: Teaching and Learning Upgrade', total: 10000 },
            { productId: '101031', skuId: '1010310002', name: 'Google Workspace for Education Plus - Legacy', total: 10000 },
            { productId: '101031', skuId: '1010310003', name: 'Google Workspace for Education Plus - Legacy (Student)', total: 0 },
            { productId: 'none', skuId: 'none', name: 'Google Workspace for Education Fundamentals', total: 1000000 }
            ]
    
            const resetting = ref(false)
                const resetError = ref(null)
                const resettingAccounts = ref(false)
                const resetAccountsError = ref(null)
    
                async function resetDemo() {
                    resetting.value = true
                    resetError.value = null
                    try {
                        await axios.get('https://us-central1-demotool-e1a5e.cloudfunctions.net/resetDemo?docId='+props.id)
                        Modal.getInstance(document.getElementById('resetDemo')).hide()
                    } catch (err) {
                        resetError.value = err.message || 'Failed to reset demo. Please try again.'
                    } finally {
                        resetting.value = false
                    }
                }
    
                async function resetAccounts() {
                    resettingAccounts.value = true
                    resetAccountsError.value = null
                    try {
                        await axios.get('https://us-central1-demotool-e1a5e.cloudfunctions.net/resetUsers?docId='+props.id)
                        Modal.getInstance(document.getElementById('resetAccounts')).hide()
                    } catch (err) {
                        resetAccountsError.value = err.message || 'Failed to reset accounts. Please try again.'
                    } finally {
                        resettingAccounts.value = false
                    }
                }

                // Issue 3: Retry failed provisioning
                const retrying = ref(false)
                async function retryProvisioning() {
                    retrying.value = true
                    try {
                        await axios.get('https://us-central1-demotool-e1a5e.cloudfunctions.net/retryProvisioning?docId='+props.id)
                    } catch (err) {
                        alert('Retry failed: ' + (err.response?.data?.error || err.message))
                    } finally {
                        retrying.value = false
                    }
                }
    
                async function updateGeminiTeen() {
                  let action = ''
                  let geminiTeenExperience = ''
                  if(!trainings.value.geminiTeenExperience){
                    action = 'remove'
                    geminiTeenExperience = false
                  }
                  else {
                    action = 'add'
                    geminiTeenExperience = true
                  }
                  axios.get('https://us-central1-demotool-e1a5e.cloudfunctions.net/manageMultipleGroupMemberships?usernamePrefix='+trainings.value.userName+'&numUsers='+trainings.value.userNumber+'&groupKey=13-18@demogfe.com&action='+action)
                  await setDoc(doc(db, 'trainings', props.id), {
                  geminiTeenExperience: geminiTeenExperience
              },{ merge: true });
                }
            
            
                const iconState = ref('clipboard'); // initial state is 'clipboard'
                const iconState2 = ref('clipboard');
    
                function copyToClipboard(value) {
                // Use the passed value for the clipboard operation
                navigator.clipboard.writeText(value);
    
                iconState.value = 'tick';
    
                setTimeout(() => {
                    iconState.value = 'clipboard';
                }, 2000);
            }
            function copyToClipboard2(value) {
                // Use the passed value for the clipboard operation
                navigator.clipboard.writeText(value);
    
                iconState2.value = 'tick';
    
                setTimeout(() => {
                    iconState2.value = 'clipboard';
                }, 2000);
            }
    
         
    
            // const newDate = moment(trainings.value.createdAt).add(1,'m').toDate()
    
            return { props, user, userInfo, trainings, moment, classrooms, licenses, languages, translated, resetDemo, domain, timeDifferenceInMinutes, adminUser, copyToClipboard, iconState, adminPassword, copyToClipboard2, iconState2, demoClassrooms, resetAccounts, updateGeminiTeen, students, resetting, resetError, resettingAccounts, resetAccountsError, retrying, retryProvisioning }
        },
        components: {
        //  "demo-content-cards": DemoContentCards,
        // "accordion": Accordion,
            
            CountdownTimer,
            ProgressTracker
    
      },
    }
    </script>
        
    <style scoped>
    .section-header {
        font-weight: 600;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 2px solid #e9ecef;
        color: #343a40;
    }
    .section-header i {
        margin-right: 0.4rem;
        color: #6c757d;
    }
    </style>